var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-container", [
    _c(
      "div",
      { staticClass: "login-form" },
      [
        _vm.$wf.isMdDown
          ? _c("div", { staticClass: "login-logo" }, [
              _c("img", { attrs: { src: require("@/assets/img/logo_c.png") } }),
            ])
          : _vm._e(),
        _c(
          "transition-group",
          { attrs: { name: "fast-fade", mode: "out-in" } },
          [
            !_vm.confirmLoginWithTotp
              ? [
                  _c(
                    "app-section",
                    { key: "a-1" },
                    [
                      _c("app-title", [
                        _vm._v(_vm._s(_vm.$ct("welcome-back-1"))),
                      ]),
                      _c("app-text", { attrs: { gray: "" } }, [
                        _vm._v(" " + _vm._s(_vm.$ct("welcome-back-3")) + " "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "app-section",
                    { key: "a-2" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          _vm.loginResult
                            ? _c(
                                "p",
                                { staticClass: "login-error" },
                                [
                                  _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "exclamation-triangle" },
                                  }),
                                  _vm._v(_vm._s(_vm.loginResult) + " "),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm.editWorksSpace
                        ? _c("w-input", {
                            staticClass: "login-input",
                            attrs: {
                              "icon-left": "globe",
                              label: _vm.$ct("workspace"),
                              disabled: _vm.disableFormElement,
                            },
                            model: {
                              value: _vm.input.workspace,
                              callback: function ($$v) {
                                _vm.$set(_vm.input, "workspace", $$v)
                              },
                              expression: "input.workspace",
                            },
                          })
                        : _vm._e(),
                      _vm.input.workspace && !_vm.editWorksSpace
                        ? _c(
                            "div",
                            { staticClass: "workspace-link" },
                            [
                              _c("span", { staticClass: "workspace-title" }, [
                                _vm._v(_vm._s(_vm.$ct("workspace-title"))),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.input.workspace) +
                                  ".winfakt.app "
                              ),
                              _c("w-fa", {
                                staticClass: "mls",
                                attrs: { icon: "edit" },
                                on: {
                                  click: function ($event) {
                                    _vm.editWorksSpace = true
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("w-input", {
                        ref: "username",
                        staticClass: "mt login-input",
                        attrs: {
                          "icon-left": "envelope",
                          label: _vm.$ct("username"),
                          autocapitalize: "none",
                          disabled: _vm.disableFormElement,
                          required: "",
                        },
                        model: {
                          value: _vm.input.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.input, "username", $$v)
                          },
                          expression: "input.username",
                        },
                      }),
                      _c("w-input", {
                        ref: "password",
                        staticClass: "mt login-input",
                        attrs: {
                          "icon-left": "lock",
                          label: _vm.$ct("password"),
                          disabled: _vm.disableFormElement,
                          password: !_vm.passwordVisible,
                          icon: _vm.passwordIconRight,
                          "icon-tooltip": _vm.passwordIconTooltip,
                          required: "",
                        },
                        on: {
                          "icon-click": function ($event) {
                            _vm.passwordVisible = !_vm.passwordVisible
                          },
                        },
                        model: {
                          value: _vm.input.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.input, "password", $$v)
                          },
                          expression: "input.password",
                        },
                      }),
                      _c(
                        "app-text",
                        { staticClass: "mt" },
                        [
                          _c(
                            "w-link",
                            {
                              staticClass: "forgot-password",
                              attrs: { to: "/forgot-password" },
                            },
                            [_vm._v(" " + _vm._s(_vm.$ct("forgot")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "app-section",
                    { key: "a-3" },
                    [
                      _c(
                        "app-button",
                        {
                          attrs: { disabled: _vm.disableButton },
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("submit")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "app-section",
                    { key: "a-4" },
                    [
                      _c(
                        "app-text",
                        [
                          _vm._v(" " + _vm._s(_vm.$ct("no-login-yet")) + " "),
                          _c("w-link", { attrs: { to: "/signup" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("create-account")) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _c("app-enter-totp", {
                  key: "totp-1",
                  on: {
                    cancel: function ($event) {
                      _vm.confirmLoginWithTotp = false
                    },
                    login: function ($event) {
                      return _vm.submitWithTotp($event)
                    },
                  },
                }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }